<template>
  <Modal
    v-if="showConfirm"
    title="確認"
    :isCloseButtonBusy="isUploading"
    :showBottomDismissButton="!isUploading"
    @close="$emit('confirm')"
    @dismiss="$emit('dismissConfirm')"
  >
    <template v-slot:body>
      <div>
        <p class="p1">CSVアップロードによるユーザーの一括更新を行います。</p>
        <p class="p1">選択ファイル: {{uploadingCsv?.name}}</p>
        <p class="p2">よろしいですか？</p>
      </div>
    </template>
  </Modal>
  <Modal
    v-if="showComplete"
    title="CSVアップロード結果"
    :showBottomDismissButton="false"
    @close="$emit('dismissComplete')"
  >
    <template v-slot:body>
      <div>
        <template v-if="csvResult?.hasErrors">
          <p class="p1">CSVアップロードに失敗しました。</p>
          <p class="p1">失敗件数: {{csvResult.failures.length}}件</p>
          <hr>
          <div class="text-danger ml8" v-for="(failure, fi) in csvResult.failures" :key="fi">
            {{failure.row.dataNum}}行目:
            <div class="ml8" v-for="(reason, ri) in failure.reasons" :key="ri">{{reason}}</div>
          </div>
        </template>
        <template v-else>
          <p class="p1">CSVアップロードに成功しました。</p>
          <p class="p1">新規件数: {{csvResult?.created.length}}件</p>
          <p class="p1">更新件数: {{csvResult?.updated.length}}件</p>
        </template>
      </div>
    </template>
  </Modal>
  <Modal
    v-if="showError"
    title="CSVエラー"
    :body="csvErrorBody"
    :showBottomDismissButton="false"
    @close="$emit('dismissError')"
  />
</template>

<script setup lang="ts">
import type { AdminUserCsvResult } from 'src/models/user';

defineProps<{
  showConfirm: boolean;
  showComplete: boolean;
  showError: boolean;
  uploadingCsv: File | null;
  csvResult: AdminUserCsvResult | null;
  csvErrorBody: string;
  isUploading: boolean;
}>();

defineEmits<{
  (e: 'confirm'): void;
  (e: 'dismissConfirm'): void;
  (e: 'dismissComplete'): void;
  (e: 'dismissError'): void;
}>();
</script>
